<div [ngSwitch]="status">
  <small class="text-dark">
    <i class="fas fa-dot-circle" [style.color]="getStatus(status, true)"></i>
    <strong>&nbsp; {{getStatus(status)}}</strong>
  </small>
</div>
